<!-- 添加节点，箭头组件 -->
<template>
    <div class="add-node-btn-box">
        <div class="add-node-btn">
            <el-popover placement="right-start" v-model="visible">
                <div class="add-node-popover-body">
                    <a class="add-node-popover-item approver" @click="addType(3)">
                        <div class="item-wrapper">
                            <span class="iconfont"></span>
                        </div>
                        <p>审批人</p>
                    </a>
                    <a class="add-node-popover-item notifier" @click="addType(4)">
                        <div class="item-wrapper">
                            <span class="iconfont"></span>
                        </div>
                        <p>抄送人</p>
                    </a>
                    <a class="add-node-popover-item condition" @click="addType(5)">
                        <div class="item-wrapper">
                            <span class="iconfont"></span>
                        </div>
                        <p>条件分支</p>
                    </a>
                </div>
                <button class="btn" type="button" slot="reference">
                    <span class="iconfont"></span>
                </button>
            </el-popover>
        </div>
    </div>
</template>
<script>
export default {
    // childNodeP:在nodeWrap.vue中获取
    props: ["childNodeP"],
    data() {
        return {
            visible: false
        }
    },
    methods: {
        addType(type) {
            console.log('添加新节点', type)
            this.visible = false;
            if (type != 5) {
                var data;
                if (type == 3) {
                    data = {
                        "nodeName": "审批人",
                        // "error": true,
                        "type": 3,
                        "setType": 3,
                        // "selectMode": 0,
                        "candidateStrategy": '1',// 审批类型使用，审批人设置 1指定成员 2角色 3发起人自选 4发起人自己 5直属 6部门 7连续多级主管 
                        "selectRange": 0,//选择范围 1.全公司 2指定成员 setType=1时使用
                        "customApproveMethod": false, // 是否自定义审批方式
                        "approveMethod": 1, //1-随机挑选一人审批，2-多人会签(按通过比例)，3-多人或签(一人通过或拒绝)，4-依次审批
                        "approveRatio": 100, // 审批比例，approveMethod=2时使用
                        "assignEmptyHandleOptions": {}, //审批人为空时处理配置
                        "nodeUserList": [],
                        // "conditionGroups":[],
                        "childNode": this.childNodeP

                    }
                } else if (type == 4) {
                    data = {
                        "nodeName": "抄送人",
                        "type": 4,
                        "setType": 4,
                        "ccSelfSelectFlag": 1,
                        "candidateStrategy": '1',
                        "childNode": this.childNodeP,
                        "nodeUserList": []
                    }
                }
                this.$emit("update:childNodeP", data)
            } else {
                this.$emit("update:childNodeP", {
                    "nodeName": "路由",
                    "type": 6,
                    "setType": 6,
                    "candidateStrategy": '0',
                    "childNode": this.childNodeP,
                    "conditionNodes": [{
                        "nodeName": "条件1",
                        "type": 5,
                        "setType": 5,
                        "isDefault": 0,
                        "candidateStrategy": '',
                        "priorityLevel": 1,
                        "conditionGroups": [],
                        "nodeUserList": [],
                        "childNode": null
                    },
                    {
                        "nodeName": "条件2",
                        "type": 5,
                        "setType": 5,
                        "isDefault": 0,
                        "candidateStrategy": '',
                        "priorityLevel": 2,
                        "conditionGroups": [],
                        "nodeUserList": [],
                        "childNode": null
                    },
                    {
                        "nodeName": "默认条件",
                        "error": true,
                        "type": 5,
                        "isDefault": 1,
                        "candidateStrategy": '',
                        "setType": 5,
                        "priorityLevel": 3,
                        "conditionGroups": [],
                        "nodeUserList": [],
                        "childNode": {
                            "nodeName": "默认审批人",
                            "type": 3,
                            "isDefault": 1,
                            "setType": 3,
                            "candidateStrategy": '1',// 审批类型使用，审批人设置 1指定成员 2角色 3发起人自选 4发起人自己 5直属 6部门 7连续多级主管 
                            "selectRange": 0,//选择范围 1.全公司 2指定成员 setType=1时使用
                            "nodeUserList": [],
                            "childNode": null
                        }
                    }]
                })
            }
        }
    }
}
</script>
<style scoped lang="less">
.add-node-btn-box {
    width: 240px;
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    -ms-flex-negative: 0;
    flex-shrink: 0;
    -webkit-box-flex: 1;
    -ms-flex-positive: 1;
    position: relative;

    &:before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: -1;
        margin: auto;
        width: 2px;
        height: 100%;
        background-color: #cacaca;
    }

    .add-node-btn {
        user-select: none;
        width: 240px;
        padding: 20px 0 32px;
        display: flex;
        -webkit-box-pack: center;
        justify-content: center;
        flex-shrink: 0;
        -webkit-box-flex: 1;
        flex-grow: 1;

        .btn {
            outline: none;
            box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
            width: 30px;
            height: 30px;
            background: #3296fa;
            border-radius: 50%;
            position: relative;
            border: none;
            line-height: 30px;
            -webkit-transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
            transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
            text-align: center;

            .iconfont {
                color: #fff;
                font-size: 16px;
            }

            &:hover {
                transform: scale(1.3);
                box-shadow: 0 13px 27px 0 rgba(0, 0, 0, 0.1);
            }

            &:active {
                transform: none;
                background: #1e83e9;
                box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
            }
        }
    }
}
</style>
<style lang="less">
.add-node-popover-body {
    display: flex;

    .add-node-popover-item {
        margin-right: 10px;
        cursor: pointer;
        text-align: center;
        flex: 1;
        color: #191f25 !important;

        p {
            text-align: center;
        }

        .item-wrapper {
            user-select: none;
            display: inline-block;
            width: 80px;
            height: 80px;
            margin-bottom: 5px;
            background: #fff;
            border: 1px solid #e2e2e2;
            border-radius: 50%;
            transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
            text-align: center;

            .iconfont {
                font-size: 35px;
                line-height: 80px;
            }
        }

        &.approver {
            .item-wrapper {
                color: #ff943e;
            }
        }

        &.notifier {
            .item-wrapper {
                color: #3296fa;
            }
        }

        &.condition {
            .item-wrapper {
                color: #15bc83;
            }
        }

        &:hover {
            .item-wrapper {
                background: #3296fa;
                box-shadow: 0 10px 20px 0 rgba(50, 150, 250, 0.4);
            }

            .iconfont {
                color: #fff;
            }
        }

        &:active {
            .item-wrapper {
                box-shadow: none;
                background: #eaeaea;
            }

            .iconfont {
                color: inherit;
            }
        }
    }
}
</style>